import api from "../config/api";

export const getAllRates = async () => {
    const response = await api.get('/rate/');
    return response.data;
};

export const getRateById = async (id) => {
    const response = await api.get(`/rate/?id=${id}`);
    return response.data;
};

export const saveRate = async (data) => {
    const response = await api.post(`/rate/bulk/`, data, {
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
};

export const deleteRate = async (id) => {
    const response = await api.delete(`/rate/?id=${id}`);
    return response.data;
};
